import { predicateFor } from '@gonfalon/legacy-form-validation/validationUtils';
import { msg } from '@gonfalon/messages/msg';
import { couldBeBoolean } from '@gonfalon/types/couldBeBoolean';
import { couldBeNumber } from '@gonfalon/types/couldBeNumber';
import { isString } from 'lodash';

import { VariationType } from '#utils/flags/flagConstants';
import { couldBeJSONValue } from '#utils/typeUtils';

// `endsWith` check is required to make sure we don't swallow periods while typing, eg '3.' => 3
// oxlint-disable-next-line
export const couldBeNumerical = (v: any) => couldBeNumber(v) && !(v.endsWith && v.endsWith('.'));

export const typechecker = {
  [VariationType.NUMBER]: couldBeNumerical,
  [VariationType.BOOLEAN]: couldBeBoolean,
  [VariationType.STRING]: isString,
  [VariationType.JSON]: couldBeJSONValue,
};

export const formatter = {
  [VariationType.NUMBER]: () => msg('flags.variationValidation.mustBeNumber'),
  [VariationType.BOOLEAN]: () => msg('flags.variationValidation.mustBeBoolean'),
  [VariationType.JSON]: () => msg('flags.variationValidation.mustBeJson'),
  [VariationType.STRING]: () => '',
};

export const matchesType = (t: VariationType) =>
  predicateFor(
    (v) => !typechecker[t](v),
    () => formatter[t](),
  );

export const valueExists = predicateFor(
  (v) => v === null || v === undefined,
  () => msg('flags.variationValidation.valueRequired'),
);
